import { Lens, AccessTime } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { classes, StyledTooltipContent } from '../config';

const TooltipContent = ({
  appointmentData, formatDate, appointmentResources,
}: any) => (
  <StyledTooltipContent className={classes.content} color={appointmentData.color}>
    <Grid container alignItems="flex-start" className={classes.titleContainer}>
      <Grid item xs={2} className={classes.textCenter}>
        <Lens className={classes.lens} />
      </Grid>
      <Grid item xs={10}>
        <div>
          <div className={`${classes.title} ${classes.dateAndTitle}`}>
            {appointmentData.title}
          </div>
          <div className={`${classes.text} ${classes.dateAndTitle}`}>
            {formatDate(appointmentData.startDate, { day: 'numeric', weekday: 'long' })}
          </div>
        </div>
      </Grid>
    </Grid>
    <Grid container alignItems="center" className={classes.contentContainer}>
      <Grid item xs={2} className={classes.textCenter}>
        <AccessTime className={classes.icon} />
      </Grid>
      <Grid item xs={10}>
        <div className={classes.text}>
          {`${formatDate(appointmentData.startDate, { hour: 'numeric', minute: 'numeric' })}
            - ${formatDate(appointmentData.endDate, { hour: 'numeric', minute: 'numeric' })}`}
        </div>
      </Grid>
    </Grid>
  </StyledTooltipContent>
);

export default TooltipContent;
